/**
 * StagingSpecialRequestSection — native special-request summary (lifted from
 * `common/StagingFlow/StagingSpecialRequestSection`, rewired onto the module
 * working context + `patchRoom`). Analytics dropped.
 */

import { BEIGE_300, BEIGE_400, BEIGE_600, GRAY_700, GRAY_900 } from 'constants/styling/theme'
import { Box, Stack, Typography } from '@mui/material'
import { FC, useCallback } from 'react'

import { BorderBoxWrapper } from 'components/common/BorderBoxWrapper'
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline'
import EditOutlinedIcon from '@mui/icons-material/EditOutlined'
import { MUIButton } from 'components/common/MUIButton'
import { useTranslation } from 'react-i18next'

import { useStagingWorkingState } from '../StagingWorkingState.context'

export const StagingSpecialRequestSection: FC = () => {
  const { t } = useTranslation(['style_selection_order_step', 'common'])
  const { setIsSpecialRequestPopupOpen, activeRoom, patchRoom } = useStagingWorkingState()

  const onEditComment = useCallback(() => {
    setIsSpecialRequestPopupOpen(true)
  }, [setIsSpecialRequestPopupOpen])

  const onRemoveComment = useCallback(() => {
    if (!activeRoom) return
    patchRoom(activeRoom.key, { comment: null })
  }, [activeRoom, patchRoom])

  if (!activeRoom) return null

  return (
    <BorderBoxWrapper padding={2} height="100%" width="100%">

      <Stack gap="1.6rem">

        <Box paddingBottom="1.2rem" borderBottom={`.1rem solid ${BEIGE_600}`}>
          <Typography variant="text-md" fontWeight="semiBold" color={GRAY_900}>
            {t('style_selection_order_step:special_request.title')}
          </Typography>
        </Box>

        <Typography variant="text-sm" color={GRAY_700}>
          {t('style_selection_order_step:special_request.request_note')}
        </Typography>

        <BorderBoxWrapper
          padding={2}
          height="100%"
          width="100%"
          elevation="none"
          backgroundColor={BEIGE_300}
          borderColor={BEIGE_400}
        >
          <Typography variant="text-sm" color={GRAY_900}>
            {activeRoom.comment}
          </Typography>
        </BorderBoxWrapper>

        <Stack gap=".8rem" flexDirection="row" justifyContent="flex-end">

          <MUIButton
            type="secondaryBorder"
            size="sm"
            startIcon={<EditOutlinedIcon fontSize="large" />}
            onClick={onEditComment}
          >
            {t('common:Edit')}
          </MUIButton>

          <MUIButton
            isIconButton
            type="orangeSecondaryNoBorder"
            size="sm"
            startIcon={<DeleteOutlineIcon fontSize="large" />}
            onClick={onRemoveComment}
          />

        </Stack>

      </Stack>

    </BorderBoxWrapper>
  )
}
